module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/cobrand-luxury-only-promo-327e64e0819d336fe759f9be075ebf30.jpg";